import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Button } from "../button";

export const SetupFailed = () => {
  const { logout } = useContext(AuthContext);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="flex flex-col h-screen w-screen items-center justify-center bg-gray-50 p-6">
      <h2 className="text-2xl font-bold mb-4">Setting up your account...</h2>
      <p className="text-gray-600 text-center mb-1">
        Your account setup is still in progress. It might take a few minutes.
      </p>
      <p className="text-gray-600 text-center mb-6">
        Please try refreshing the page.
      </p>
      <div className="flex justify-items space-x-4">
        <Button onClick={handleRefresh}>Refresh page</Button>

        <a
          onClick={logout}
          className="px-4 py-2 bg-gray-700 text-white rounded-md hover:bg-black transition duration-300 cursor-pointer"
        >
          Logout
        </a>
      </div>
    </div>
  );
};
